var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMoreInfoLarge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "More_information",
    "data-name": "More information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-button",
    transform: "translate(6.088 6.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5897",
    "data-name": "Path 5897",
    d: "M8.971,0a8.971,8.971,0,1,0,8.972,8.971A8.971,8.971,0,0,0,8.971,0Zm1.868,13.9q-.693.273-1.105.416a2.915,2.915,0,0,1-.958.144,1.91,1.91,0,0,1-1.3-.409,1.321,1.321,0,0,1-.464-1.038,3.771,3.771,0,0,1,.034-.5c.024-.17.061-.362.112-.576L7.731,9.9c.051-.2.095-.382.13-.555a2.462,2.462,0,0,0,.052-.481.74.74,0,0,0-.161-.545.915.915,0,0,0-.617-.153,1.62,1.62,0,0,0-.459.068c-.156.048-.291.091-.4.134l.153-.629q.567-.231,1.086-.4a3.209,3.209,0,0,1,.98-.166,1.875,1.875,0,0,1,1.285.4,1.337,1.337,0,0,1,.451,1.045q0,.133-.031.469a3.136,3.136,0,0,1-.115.616l-.575,2.035c-.047.163-.089.35-.127.559a2.956,2.956,0,0,0-.055.475.683.683,0,0,0,.182.553,1.016,1.016,0,0,0,.628.147,1.822,1.822,0,0,0,.475-.074,2.7,2.7,0,0,0,.384-.129Zm-.1-8.261a1.372,1.372,0,0,1-.968.374A1.386,1.386,0,0,1,8.8,5.642a1.193,1.193,0,0,1-.4-.906,1.2,1.2,0,0,1,.4-.908,1.376,1.376,0,0,1,.972-.377,1.361,1.361,0,0,1,.968.377,1.224,1.224,0,0,1,0,1.814Z",
    transform: "translate(-3.06 -3.06)",
    fill: "#ed8b00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreInfoLarge);
export default __webpack_public_path__ + "static/media/icon_more_info_large.c62b991b8e287cf3e630bfb167ae9775.svg";
export { ForwardRef as ReactComponent };